export default __webpack_public_path__ + "static/media/SB_Rectangle3.4503ed76.svg";